import { applyHighchartsTheme } from "../utils/highcharts_theme"

export const TransactionValueTrends = {
  mounted() {
    this.handleEvent("render-transaction-value-trends", ({ chart_data }) => {
      this.renderChart(chart_data)
    })

    // Also render on mount if data is present
    const chartData = this.el.dataset.chart
    if (chartData) {
      this.renderChart(JSON.parse(chartData))
    }
  },

  renderChart(chartData) {
    const currencySymbol = chartData.currency_symbol || ""

    import("highcharts").then((Highcharts) => {
      applyHighchartsTheme(Highcharts.default)
      Highcharts.default.chart(this.el.id, {
        chart: {
          type: "line",
          // Highcharts 13 defaults chart.backgroundColor to a CSS var that
          // renders dark under prefers-color-scheme: dark; keep it explicit.
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: chartData.categories,
          title: {
            text: "Time Period",
          },
        },
        yAxis: {
          title: {
            text: `Transaction Value (${currencySymbol})`,
          },
          min: 0,
          labels: {
            formatter: function () {
              return (
                currencySymbol +
                this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              )
            },
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          valuePrefix: currencySymbol,
          valueDecimals: 0,
          pointFormatter: function () {
            return (
              '<span style="color:' +
              this.color +
              '">\u25CF</span> ' +
              this.series.name +
              ": <b>" +
              currencySymbol +
              this.y.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              "</b><br/>"
            )
          },
        },
        plotOptions: {
          line: {
            color: "#a855f7",
            dataLabels: {
              enabled: false,
            },
            marker: {
              enabled: true,
              radius: 4,
            },
          },
        },
        series: [
          {
            name: "Median Transaction Value",
            data: chartData.data,
          },
        ],
        credits: {
          enabled: false,
        },
      })
    })
  },
}
